export default __webpack_public_path__ + "assets/imgs/preto_caramelo_3.e59beb5b.png";